const permissions = {
  agentList: 'MB017',
  agentAdd: 'MB018',
  agentEdit: 'MB019',
  agentDelete: 'MB020'
};

export default permissions;
